import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

if (!clientId) {
  throw new Error(
    "VITE_GOOGLE_CLIENT_ID is not set in your environment variables."
  );
}

export const GoogleOAuthProviderWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>
);
